import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d7c3c1b6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "description-header-title"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description-header-content"
}, [/*#__PURE__*/_createElementVNode("span", null, "维护收费规则信息")], -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "免费时长", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "计费时间", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1));
const _hoisted_6 = {
  key: 1,
  style: {
    "margin-bottom": "10px"
  }
};
const _hoisted_7 = {
  class: "content-title"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info-message"
}, [/*#__PURE__*/_createElementVNode("div", null, "1：只有一个明细：表示没有首次费用"), /*#__PURE__*/_createElementVNode("div", null, "2：多个明细：第一个为首次费用，后续为阶梯费用")], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_layout_breadcrumb = _resolveComponent("layout-breadcrumb");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_time_select = _resolveComponent("el-time-select");
  const _component_el_radio_button = _resolveComponent("el-radio-button");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_form = _resolveComponent("el-form");
  const _component_form_page = _resolveComponent("form-page");
  const _directive_permission = _resolveDirective("permission");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_layout_breadcrumb, {
    topMenuId: _ctx.topMenuId,
    onChangeTopToMenu: _ctx.changeTopToMenu,
    topMenuClick: _ctx.topMenuClick
  }, {
    description: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", null, _toDisplayString(`${$data.edit ? '修改' : '增加'}收费规则`), 1)]), _hoisted_2]),
    _: 1
  }, 8, ["topMenuId", "onChangeTopToMenu", "topMenuClick"]), _createVNode(_component_form_page, null, {
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.formModel,
      rules: $data.formRules,
      class: "normal-form",
      ref: "formRef",
      "label-width": "160px"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "规则编码",
        prop: "code"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.formModel.code,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.formModel.code = $event),
          placeholder: "请输入规则编码"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_row, {
        gutter: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "freeDuration"
          }, {
            label: _withCtx(() => [_createElementVNode("div", null, [_hoisted_3, _createVNode(_component_el_popover, {
              trigger: "hover",
              content: "单位：分钟"
            }, {
              reference: _withCtx(() => [_createVNode(_component_el_icon, {
                class: "iconfont icon-question-circle",
                style: {
                  "padding-left": "5px"
                }
              })]),
              _: 1
            })])]),
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: $data.formModel.freeDuration,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.formModel.freeDuration = $event),
              placeholder: "请输入免费时长",
              step: 1,
              precision: 0,
              min: 0
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "计入费用时长",
            prop: "freeFee"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: $data.formModel.freeFee,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.formModel.freeFee = $event),
              "active-text": "计入",
              "inactive-text": "不计入"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        required: ""
      }, {
        label: _withCtx(() => [_createElementVNode("div", null, [_hoisted_4, _createVNode(_component_el_popover, {
          trigger: "hover",
          content: "开始时间大于截止时间表示跨天"
        }, {
          reference: _withCtx(() => [_createVNode(_component_el_icon, {
            class: "iconfont icon-question-circle",
            style: {
              "padding-left": "5px"
            }
          })]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 11
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "beginTime"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_time_select, {
              modelValue: $data.formModel.beginTime,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.formModel.beginTime = $event),
              placeholder: "开始时间",
              start: "00:00",
              step: "00:01",
              end: "23:59",
              style: {
                "width": "100%"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          style: {
            "text-align": "center"
          },
          span: 2
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 11
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "endTime"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_time_select, {
              modelValue: $data.formModel.endTime,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.formModel.endTime = $event),
              placeholder: "截止时间",
              start: "00:00",
              step: "00:01",
              end: "23:59",
              style: {
                "width": "100%"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "封顶金额",
        prop: "maxFee"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          modelValue: $data.formModel.maxFee,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.formModel.maxFee = $event),
          placeholder: "请输入封顶金额",
          step: 1,
          precision: 2,
          min: 0
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "费用类型",
        prop: "feeType"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_group, {
          modelValue: $data.formModel.feeType,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.formModel.feeType = $event),
          onChange: $options.feeTypeChange
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_button, {
            label: "按时收费"
          }), _createVNode(_component_el_radio_button, {
            label: "按次收费"
          })]),
          _: 1
        }, 8, ["modelValue", "onChange"])]),
        _: 1
      }), $data.formModel.feeType === '按次收费' ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 0,
        label: "每次费用",
        prop: "timesFee"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          modelValue: $data.formModel.timesFee,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.formModel.timesFee = $event),
          placeholder: "请输入每次费用",
          step: 1,
          precision: 2,
          min: 0
        }, null, 8, ["modelValue"])]),
        _: 1
      })) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createTextVNode(" 按时收费规则明细 "), _createVNode(_component_el_popover, {
        width: 300,
        trigger: "hover",
        content: "开始时间大于截止时间表示跨天"
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_icon, {
          class: "iconfont icon-question-circle"
        })]),
        default: _withCtx(() => [_hoisted_8]),
        _: 1
      })]), _createVNode(_component_el_divider), _createVNode(_component_el_table, {
        data: $data.formModel.items,
        border: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "阶梯",
          width: "70px",
          prop: "seq"
        }), _createVNode(_component_el_table_column, {
          label: "计费时长"
        }, {
          default: _withCtx(scope => [_withDirectives(_createElementVNode("p", null, _toDisplayString(scope.row.duration), 513), [[_vShow, !scope.row.editable]]), _withDirectives(_createVNode(_component_el_input_number, {
            modelValue: scope.row.duration,
            "onUpdate:modelValue": $event => scope.row.duration = $event,
            step: 1,
            precision: 0,
            min: 0
          }, null, 8, ["modelValue", "onUpdate:modelValue"]), [[_vShow, scope.row.editable]])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "计费金额"
        }, {
          default: _withCtx(scope => [_withDirectives(_createElementVNode("p", null, _toDisplayString(scope.row.fee), 513), [[_vShow, !scope.row.editable]]), _withDirectives(_createVNode(_component_el_input_number, {
            modelValue: scope.row.fee,
            "onUpdate:modelValue": $event => scope.row.fee = $event,
            step: 1,
            precision: 2,
            min: 0
          }, null, 8, ["modelValue", "onUpdate:modelValue"]), [[_vShow, scope.row.editable]])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [scope.row.editable ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            onClick: $event => scope.row.editable = false,
            type: "success"
          }, {
            default: _withCtx(() => [_createTextVNode("确定 ")]),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true), !scope.row.editable ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            link: "",
            onClick: $event => scope.row.editable = true,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("修改 ")]),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
            link: "",
            onClick: $event => $options.deleteItem(scope.row),
            type: "danger"
          }, {
            default: _withCtx(() => [_createTextVNode("删除")]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])])), _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [$data.formModel.feeType === '按时收费' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          onClick: $options.addItem
        }, {
          default: _withCtx(() => [_createTextVNode("增加规则明细")]),
          _: 1
        }, 8, ["onClick"])) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: $options.submitForm
        }, {
          default: _withCtx(() => [_createTextVNode("保存 ")]),
          _: 1
        }, 8, ["onClick"])), [[_directive_permission, ['feeRule_add', 'feeRule_edit']]]), _createVNode(_component_el_button, {
          onClick: _cache[8] || (_cache[8] = () => {
            this.$router.go(-1);
          })
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  })]);
}